<template>
  <button
    class="button"
    :class="classesBtn"
    :id="id"
    :title="title"
    :style="{
      width: width,
      height: height,
      'font-size': fontSize,
    }"
    :type="type"
  >
    <span v-if="temIcon" class="icon is-small">
      <i class="mdi" :class="classIcon"></i>
    </span>
    <span>{{ nome }}</span>
  </button>
</template>

<script>
export default {
  name: "TrfButton",
  props: {
    nome: String,
    classCor: String,
    temIcon: Boolean,
    classIcon: String,
    id: String,
    width: String,
    height: String,
    fontSize: String,
    type: String,
    title: String,
    isBtnLoading: Boolean
  },
  computed: {
    classesBtn() {
      const classObject = {};
      classObject['is-loading'] = this.isBtnLoading;
      classObject[this.classCor] = !!this.classCor;
      return classObject;
    }
  }
};
</script>
